import { PersonalBonus } from '@widgets/personal/bonus'
import { PersonalHistory } from '@widgets/personal/history'
import { PersonalCoupons } from '@widgets/personal/сoupons'

// import { PersonalOffers } from "@widgets/personal/offers";
// import { PersonalPromoCodes } from "@widgets/personal/promo-codes";
import styles from './styles.module.scss'


export default function LoyaltyPage () {
  return (
    <div className={styles.root}>
      <PersonalBonus />
      <PersonalHistory />
      <PersonalCoupons />
      {/* <PersonalOffers /> //временно скрываем */}
      {/* <PersonalPromoCodes /> //временно скрываем */}
    </div>
  )
}